<template>
  <div v-loading="loading">
    <page-heading
      heading="Шкалы оценки"
    >
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            style="margin-left: 20px"
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="scaleCreate"
          >
            Создать шкалу
          </el-button>
        </div>
      </div>
    </page-heading>
    <div>
      <el-card
        v-if="!scales.length"
        class="template-card"
      >
      <div class="el-table__empty-block" style=""><span class="el-table__empty-text">Нет созданных шкал</span></div>
      </el-card>
      <el-card
        v-for="scale in scales"
        :key="scale.id"
        class="template-card"
        style="margin-bottom: 35px"
      >
        <scale-component
          :scale.sync="scale"
          @scale-update="getScales"
        ></scale-component>
      </el-card>
    </div>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading.vue";
import ScaleComponent from "@/modules/evaluation/components/scale/ScaleComponent.vue";
export default {
  name: "scales-component",
  components: { ScaleComponent, PageHeading },
  data() {
    return {
      loading: false,
      scales: [],
    }
  },
  mounted() {
    this.getScales();
  },
  methods: {
    getScales() {
      this.loading = true;
      this.$api.evaluation.scaleSearch({
        expand: ['options'].join(),
      })
        .then(({data}) => {
          this.scales = data.scales;
        })
        .finally(() => {
          this.loading = false;
        })
    },
    scaleCreate() {
      this.loading = true;
      this.$api.evaluation.scaleCreate({
        competence_id: this.$route.params.id,
      })
        .then(({data}) => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Шкала успешно создана'
          });
          this.getScales();
        });
    },
  }
}
</script>

<style scoped>

</style>